import axios from "axios"
import * as Sentry from "@sentry/browser"
import store from "./../store"
/**
 * Create a new Axios client instance
 * @see https://github.com/mzabriskie/axios#creating-an-instance
 */
const getClient = (baseUrl = null, token = null, local = false) => {
  const options = {
    baseURL: process.env.VUE_APP_API_URL + baseUrl,
  }

  const client = axios.create(options)

  // Add a request interceptor
  client.interceptors.request.use(
    (requestConfig) => {
      requestConfig.headers = {
        Authorization: `Bearer ${token ? token : store.getters["pilot/accessToken"]}`,
      }
      return requestConfig
    },
    (requestError) => {
      Sentry.setExtra("error", requestError)
      Sentry.captureException(requestError)
      return Promise.reject(requestError)
    }
  )

  // Add a response interceptor
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      // Network error
      /*if (!error.response) {
        console.log("Network error")
        // store API REQUESTS to be able to sync once is back online
        if (store.getters["grid/isOffline"] === false) {
          store.commit("grid/setIsOffline", true)
        }
        return
      }*/
      /* if (error.response.status >= 500) {
        Raven.captureException(error)
      } */

      Sentry.setExtra("error", error)
      Sentry.captureException(error)
      return Promise.reject(error)
    }
  )

  return client
}

class ApiClient {
  constructor(baseUrl = null, token = null, local = false) {
    this.client = getClient(baseUrl, token, local)
  }

  get(url, conf = {}) {
    return this.client
      .get(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  }

  delete(url, conf = {}) {
    return this.client
      .delete(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  }

  head(url, conf = {}) {
    return this.client
      .head(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  }

  options(url, conf = {}) {
    return this.client
      .options(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  }

  post(url, data = {}, conf = {}) {
    return this.client
      .post(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  }

  put(url, data = {}, conf = {}) {
    return this.client
      .put(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  }

  patch(url, data = {}, conf = {}) {
    return this.client
      .patch(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  }
}

export { ApiClient }

/**
 * Base HTTP Client
 */
export default {
  // Provide request methods with the default base_url
  get(url, conf = {}) {
    return getClient()
      .get(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },

  delete(url, conf = {}) {
    return getClient()
      .delete(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },

  head(url, conf = {}) {
    return getClient()
      .head(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },

  options(url, conf = {}) {
    return getClient()
      .options(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },

  post(url, data = {}, conf = {}) {
    return getClient()
      .post(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },

  put(url, data = {}, conf = {}) {
    return getClient()
      .put(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },

  patch(url, data = {}, conf = {}) {
    return getClient()
      .patch(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
}
